import styled from 'styled-components';

import breakpoints from '../styles/breakpoints';

export const Article = styled.article`
  margin: 40px 0 60px 0;

  ${breakpoints.medium`
    margin: 53px 0 80px 0;
  `};

  ${breakpoints.large`
     margin: 60px 0 160px 0;
  `};
`;

export const Section = styled.section`
  margin: 40px 0 60px 0;

  ${breakpoints.medium`
    margin: 53px 0 80px 0;
  `};

  ${breakpoints.large`
    margin: 60px 0 160px 0;
  `};
`;

export const Title = styled.h1`
  color: ${p => p.theme.colors.darkFont};
  font-size: 1.875rem;
  font-weight: 900;
  letter-spacing: 0.6px;
  line-height: 1.2;
  margin: 0 0 50px 0;
  text-align: center;

  ${breakpoints.medium`
    font-size: 2.5rem;
  `};

  ${breakpoints.large`
    font-size: 3.75rem;
  `};
`;

export const Intro = styled.div`
  color: ${p => p.theme.colors.lightFont};
  font-size: 1.125srem;
  font-weight: 500;
  letter-spacing: 0.3px;
  line-height: 1.666666667;
  margin: 0 auto 60px auto;
  max-width: ${p => p.theme.globalWidthXSmall};
  text-align: center;

  ${breakpoints.medium`
    font-size: 1.25rem;
    line-height: 2;
  `};

  ${breakpoints.large`
    font-size: 1.5625rem;
    line-height: 1.6;
  `};
`;

export const Excerpt = styled(Intro)``;

export const FeaturedImage = styled.img`
  display: block;
  margin: 0 auto;
  margin-bottom: 50px;
  max-width: ${p => p.theme.globalWidthSmall};
  width: 100%;

  ${breakpoints.medium`
    margin-bottom: 60px;
  `};
`;

export const Content = styled.div`
  margin: 0 auto 60px auto;
  max-width: ${p =>
    p.wide ? p.theme.globalWidthSmall : p.theme.globalWidthXSmall};
`;

export const WideContent = styled.div`
  margin: 0 auto 60px auto;
  max-width: ${p => (p.wide ? p.theme.globalWidthLarge : p.theme.globalWidth)};
`;

export default Article;
